// extracted by mini-css-extract-plugin
module.exports = {"unusedCarouselSpace":"92px","filter":"_3m1O_d","isSticky":"_2gQaSQ","filterLabel":"_2vgzfA","primeLogo":"_3bzPlH","fadeInFrames":"_159_Hg"};